import { createHashHistory } from 'history';

// Using hash history in order to sync the location with the store.
export default createHashHistory();
